package com.macrofocus.eflux.ui.data.risk

import mui.icons.material.FloodTwoTone
import mui.material.*
import mui.system.sx
import react.FC
import react.ReactNode
import react.dom.events.MouseEventHandler
import web.cssom.Color
import web.svg.SVGSVGElement

val FloodingBadge = FC<RiskBadgeProps> { props ->
    Tooltip {
        title = ReactNode("flooding")
        placement = TooltipPlacement.bottom
        Badge {
            color = if(props.disabled == true) BadgeColor.info else BadgeColor.error
            sx {
                if(props.disabled == true) {
                    "& .MuiBadge-badge" {
                        backgroundColor = Color("#9e9e9e") // MUI grey[500]
//                    color = Color("white") // text color
                    }
                }
            }
            FloodingIcon {
                if(props.badgeContent == null || props.disabled == true) {
                    color = SvgIconColor.disabled
                }
                onClick = props.onClick.unsafeCast<MouseEventHandler<SVGSVGElement>>()
            }

            +props
            // The icon above is the Badge child; drop any forwarded `children` to avoid "Both `children` source options used"
            children = null
        }
    }
}

val FloodingIcon = FloodTwoTone
